import {ReactElement} from 'react'

// A panel with its left column and an arrow into it: collapse to the rail.
export const DopamineAssistantCollapseIcon = (): ReactElement => (
  <svg
    aria-hidden="true"
    fill="none"
    height="16"
    viewBox="0 0 24 24"
    width="16"
  >
    <rect
      height="16"
      rx="2.5"
      stroke="currentColor"
      strokeWidth="1.7"
      width="19"
      x="2.5"
      y="4"
    />
    <path
      d="M9.5 4v16M19 12h-6M15.4 9.6L13 12l2.4 2.4"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="1.7"
    />
  </svg>
)
